import { Pipe, PipeTransform } from '@angular/core';
import { FrequencyTranslationService } from './frequency-translation.service';

@Pipe({
    name: 'frequencyTranslation',
    pure: false,
    standalone: false,
})
export class FrequencyTranslationPipe implements PipeTransform {
    constructor (private frequencyTranslationService: FrequencyTranslationService) {}

    transform (frequency?: number): string {
        return this.frequencyTranslationService.getFrequencyTranslation(frequency);
    }
}
